import GridTheme from '../gridTheme';

const sizes = GridTheme.flexboxgrid.breakpoints;

const media = Object.keys(sizes).reduce((acc, label) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  acc[label] = `@media (max-width: ${sizes[label]}em)`;

  return acc;
}, {});

export default media;
